import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { CargoDetailComponent } from '../cargo-detail/cargo-detail.component';
import { Utils } from 'src/app/core/resources/utils';
import { AssignVehicleCargoComponent } from '../assign-vehicle-cargo/assign-vehicle-cargo.component';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Cargo } from 'src/app/core/interfaces/cargo';

@Component({
  selector: 'app-avaliable-cargo-list',
  templateUrl: './avaliable-cargo-list.component.html',
  styleUrls: ['./avaliable-cargo-list.component.scss']
})
export class AvaliableCargoListComponent implements OnInit {
  @ViewChild(AssignVehicleCargoComponent)
  assignVehicleCargoComponent: AssignVehicleCargoComponent;
  permission = Permission;
  invalidVehicle: boolean = true;
  rotateArrowStates: boolean[] = [];
  constructor(
    public dialogRef: MatDialogRef<AvaliableCargoListComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogParams: { licensePlate: string, numberOfTrips: number, filteredCargosTurns?: { turnId?: string, matches?: Cargo[] } },
    public utils: Utils,
    public matDialog: MatDialog,
    public permissionRole: PermissionRole
  ) { }

  ngOnInit() { }
  onClickDiv(index: number) {
    this.rotateArrowStates[index] = !this.rotateArrowStates[index];
  }
  openDetailCargo(cargo) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.utils.clone(cargo),
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.matDialog.open(CargoDetailComponent, dialogConfig);
  }

  async assignCargoToTurn(cargo: Cargo) {
    const { canContinue } = await this.assignVehicleCargoComponent.getVehicleInfo(this.dialogParams.licensePlate);
    if (!canContinue) return;
    this.confirmAssignCargo(cargo, this.dialogParams.licensePlate);
  }

  confirmAssignCargo(cargo, licensePlate: string) {
    const dialogConfig = new MatDialogConfig();
    const title = `¿Está seguro de asignar el vehículo ${licensePlate} al servicio ${cargo.consecutive}?`;
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.assignVehicleCargoComponent.onSubmit('turns');
      }
    });
  }

  onAssignVehicle() {
    this.dialogRef.close({ state: true });
  }

  get assignTurnVehicles(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.assignTurnVehicles);
  }


}
